import { ActivityTypeKey as ActivityTypeKeySource } from "@/types/activity"

export enum ActivityTypeKey {
  training = "T",
  league = "L",
  cup = "C",
  friendlyMatch = "F",
  rehab = "R",
  etc = "E",
}

export enum ActivityTypeKeyReverse {
  T = "training",
  L = "league",
  C = "cup",
  F = "friendlyMatch",
  R = "rehab",
  E = "etc",
}

export const activityType: { [key: string]: ActivityTypeKey } = {
  training: ActivityTypeKey.training,
  league: ActivityTypeKey.league,
  cup: ActivityTypeKey.cup,
  friendlyMatch: ActivityTypeKey.friendlyMatch,
  rehab: ActivityTypeKey.rehab,
  etc: ActivityTypeKey.etc,
}

// 액티비티 타입 정렬 순서. 원천은 types/activity.ts 의 ActivityTypeKey 선언 순서.
// 두 동명 enum 의 순서는 T, L, C, F, R, E 로 통일됨 — 이중 정의 자체의 통합은 WEB-2275 에서.
export const ACTIVITY_TYPE_ORDER: Record<string, number> = Object.fromEntries(
  Object.values(ActivityTypeKeySource).map((key, index) => [key, index + 1]),
)
